import { render, staticRenderFns } from "./IndexBannerSw.vue?vue&type=template&id=07d20b4e&"
import script from "./IndexBannerSw.vue?vue&type=script&lang=js&"
export * from "./IndexBannerSw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports